var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"dense":"","app":""}},[_c('v-container',{staticClass:"pa-0 d-flex",attrs:{"fluid":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.$emit('update:drawer', !_vm.drawer)}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('s-profile-menu')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }